import { action, computed, observable } from 'mobx';
import { useState } from 'react';

export function useClassStore<StoreType>(initialValue: StoreType) {
  const [store] = useState(initialValue);

  return store;
}

export class ObservableProp<T> {
  @observable private _value?: T = undefined; // must provide a value otherwise mobx won't pickup

  constructor(initialValue: T) {
    this._value = initialValue;
  }

  @computed get value() {
    return this._value as T; // we can safely assume the value defined since we initialize in constructor
  }

  @action set(value: T) {
    this._value = value;
  }
}

export type TransientClass = {
  destroy: () => void;
};
